const PhotoForm = ({}) => {
	return <div>PhotoForm</div>;
};
export default PhotoForm;
